import { Injectable } from '@angular/core';
import * as pdfjsLib from 'pdfjs-dist';

pdfjsLib.GlobalWorkerOptions.workerSrc = '/assets/pdf.worker.bootstrap.mjs';

@Injectable({
  providedIn: 'root'
})
export class PdfThumbnailService {

  async generateThumbnail(pdfUrl: string): Promise<string> {
    // Carica il file PDF
    // console.log('pdfurl',pdfUrl)
    const pdf: pdfjsLib.PDFDocumentProxy = await pdfjsLib.getDocument(pdfUrl).promise;

    // Ottieni la prima pagina
    const page = await pdf.getPage(1);

    // Crea un canvas
    const canvas = document.createElement('canvas');
    const viewport = page.getViewport({ scale: 1 });
    canvas.width = viewport.width;
    canvas.height = viewport.height;

    await page.render({
      canvas,
      viewport,
    }).promise;

    // Converti il canvas in data URL
    return canvas.toDataURL();
  }
}
